import React, { PropsWithChildren, useContext } from "react";
import { PublicConfigurationContext } from "../Context";
import { getAICoachConfig } from "@aidkitorg/types/lib/config";
import { ChatConversationProvider } from "../Contexts/ChatContext";
import { AudioInterfaceProvider } from "../Contexts/AudioInterfaceContext";
import { DefaultChatSessionProvider } from "../Contexts/ChatSessionContext";

export type AICoachState = {
  enabled: boolean,
  config?: ReturnType<typeof getAICoachConfig>,
};

const defaults: AICoachState = {
  enabled: false
}

export const AICoachContext = React.createContext<AICoachState>(defaults);

export function AICoachProvider({ children }: PropsWithChildren): JSX.Element {

  const config = useContext(PublicConfigurationContext);

  const limitToSubsurveys = config.capabilities?.aiCoach?.limitToSubsurveys ?? [];
  const enabled = !!config.capabilities?.aiCoach && !config.capabilities?.aiCoach?.disabled 
    && (!limitToSubsurveys.length || limitToSubsurveys.includes(window.location.pathname.replace(/^\/(p\/)*/ig, '').split('/')[0].toLowerCase()))

  const stateValue: AICoachState = {
    config: config.capabilities?.aiCoach,
    enabled
  };

  if(!enabled) {
    return <>{children}</>;
  }

  return <AudioInterfaceProvider>
    <ChatConversationProvider>
      <DefaultChatSessionProvider>
        <AICoachContext.Provider value={stateValue}>
          {children}
        </AICoachContext.Provider>
      </DefaultChatSessionProvider>
    </ChatConversationProvider>
  </AudioInterfaceProvider>;
}

// sugar
export function useAICoach(): AICoachState {
  const AICoach = useContext(AICoachContext);
  return AICoach;
}
